// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGrid1XL = class TeaserBoxInnerGrid1XL extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.tileConfig = {
            isPremium: this.teaserBoxConfig.isPremium,
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            showAuthorAvatar: this.teaserBoxConfig.showAuthorAvatar,
            showAuthorName: this.teaserBoxConfig.showAuthorName,
            showCategory: this.teaserBoxConfig.showCategory,
            showPublicationDate: this.teaserBoxConfig.showPublicationDate,
            showTitle: true,
            size: TileSize.XL,
            titleOnImage: true,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
    }
};
TeaserBoxInnerGrid1XL.moduleVersion = TeaserBoxVersion['1XL'];
TeaserBoxInnerGrid1XL = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid1XL',
        components: { InnerGridWrapper, Tile },
        template: `
    <InnerGridWrapper>
      <Tile v-if="articles[0]" v-bind="{ ...tileConfig, fallbackImage, windowService, isLazy, isMobile }"
            :article="articles[0]" />
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGrid1XL);
export { TeaserBoxInnerGrid1XL };
